export const cartOptionTmpl = ({ key, name }) => {
  return `<span class="key">${key}</span><span>${name}</span>`;
};
